import { Component, OnInit, Output, EventEmitter } from '@angular/core';

import { NbDialogService, NbDateService, NbToastrService } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'filter-period',
  templateUrl: './filter-period.component.html',
  styleUrls: ['./filter-period.component.css']
})
export class FilterPeriodComponent implements OnInit {

  @Output() filterPeriodClicked: EventEmitter<any> = new EventEmitter();

  public selectedStartPeriod: Date;
  public selectedEndPeriod: Date;
  public selectedStartTimePeriod: string = '00:00';
  public selectedEndTimePeriod: string = '23:59';

  private max: Date;
  private disableEndPicker: boolean;
  private filterPeriod: {
    selectedStartPeriod: Date,
    selectedEndPeriod: Date,
    selectedStartTimePeriod: string,
    selectedEndTimePeriod: string
  }

  constructor(protected dateService: NbDateService<Date>, private translate: TranslateService) { }

  ngOnInit(): void {
    this.max = this.dateService.addMonth(this.dateService.today(), 0);
    this.selectedStartPeriod = new Date(new Date().setHours(0, 0, 0));
    this.selectedEndPeriod = new Date(new Date().setHours(23, 59, 59));
    this.disableEndPicker = true;

    this.filterPeriod = {
      selectedStartPeriod: this.selectedStartPeriod,
      selectedEndPeriod: this.selectedEndPeriod,
      selectedStartTimePeriod: this.selectedStartTimePeriod,
      selectedEndTimePeriod: this.selectedEndTimePeriod
    }
  }

  changeEndPickerStatus(): void {
    this.selectedEndPeriod = null;
    if (this.selectedStartPeriod == null) {
      this.disableEndPicker = true;
      return
    }
    this.disableEndPicker = false;
    this.changePickerStatus();
  }

  changePickerStatus(){
    this.filterPeriod = {
      selectedStartPeriod: this.selectedStartPeriod,
      selectedEndPeriod: this.selectedEndPeriod,
      selectedStartTimePeriod: this.selectedStartTimePeriod,
      selectedEndTimePeriod: this.selectedEndTimePeriod
    }

    this.filterPeriodClicked.emit(this.filterPeriod);
  }

}
